import { CancelFilled } from '@interhyp/platform-icons';
import classNames from 'classnames';
import { BaseCardLabel } from "./components/BaseCardLabel.js";
import { ClickableDiv } from "../../helper/components/ClickableDiv.js";
import { IconRenderer } from "../../helper/components/IconRenderer.js";
import { MaybeWrapper } from "../../helper/components/MaybeWrapper.js";
import styles from "./BaseCard.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ALinkTag = ({
  to,
  className,
  children
}) => {
  return /*#__PURE__*/_jsx("a", {
    href: to,
    className: className,
    children: children
  });
};
export function BaseCard({
  labelText,
  labelIcon,
  labelColor = 'INFO',
  selected = false,
  variant,
  onClick,
  onClose,
  closeAriaLabel,
  children,
  href,
  linkTag
}) {
  const clickable = !!onClick || !!href;
  const hasLabel = !!labelText;
  const closable = !!onClose;
  const innerCardClassName = classNames(styles.innerCard, styles.link, {
    [styles.selected]: selected
  });
  const Link = linkTag ?? ALinkTag;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames(styles.card, styles[`color${labelColor}`], styles[variant], {
      [styles.clickable]: clickable,
      [styles.hasLabel]: hasLabel
    }),
    children: [/*#__PURE__*/_jsx(MaybeWrapper, {
      condition: !!href,
      wrapper: c => /*#__PURE__*/_jsx(Link, {
        to: href,
        className: styles.link,
        children: c
      }),
      children: onClick ? /*#__PURE__*/_jsxs(ClickableDiv, {
        onClick: onClick,
        className: innerCardClassName,
        children: [/*#__PURE__*/_jsx(BaseCardLabel, {
          labelText: labelText,
          labelIcon: labelIcon
        }), children]
      }) : /*#__PURE__*/_jsxs("div", {
        className: innerCardClassName,
        children: [/*#__PURE__*/_jsx(BaseCardLabel, {
          labelText: labelText,
          labelIcon: labelIcon
        }), children]
      })
    }), closable && /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.closeButton,
      onClick: e => {
        e.stopPropagation();
        onClose?.();
      },
      "aria-label": closeAriaLabel ?? 'Schließen',
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.closeButtonBackground
      }), /*#__PURE__*/_jsx(IconRenderer, {
        icon: CancelFilled,
        className: styles.closeButtonIcon
      })]
    })]
  });
}